import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import { useFormik } from "formik";
import React, { useCallback, useEffect } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router";
import * as Yup from "yup";
import DetailView from "../../../components/UI/DetailView/DetailView";
import AddressCard from "../../../components/UI/Person/AddressCard/AddressCard";
import IdentificationCard from "../../../components/UI/Person/IdentificationCard/IdentificationCard";
import useApiClient from "../../../hooks/apiClient";
import apiRoutes from "../../../hooks/apiClient.routes";
import EmployeeCard from "./EmployeeCard";

const initialValues = {
  id: "",
  type: "1",
  name: "",
  publicName: "",
  taxId: "",
  gender: "",
  birth: null,
  phone1: "",
  phone2: "",
  phone3: "",
  email: "",
  addressLine1: "",
  number: "",
  addressLine2: "",
  neighborhood: "",
  city: "",
  state: "",
  zip: "",
  info: "",

  position: "",
  positionShortDescription: "",
  bloodType: "Desconhecido",
  garageStaff: false,
  allergies: "",
  medicalKnownConditions: "",
  pis: "",
  ctps: "",
  emergencyContacts: [],
  admission: null,
  termination: null,
};

const validationSchema = Yup.object({
  name: Yup.string().required("Informe o nome"),
});

const TeamDetail = (props) => {
  const navigate = useNavigate();
  const { request, data, errors, loading, requestId } = useApiClient();

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      request(apiRoutes.main.person.employeeSave, values);
    },
  });

  const { values, setSubmitting, setStatus, setErrors } = formik;

  useEffect(() => {
    if (data || errors) setSubmitting(false);

    if (data && data.success) {
      toast.success("Salvo com sucesso");
      navigate(-1);
    }

    if (errors) {
      if (errors.status) setStatus(errors.status);
      if (errors.schema) setErrors({ ...errors.schema });
    }
  }, [data, errors, requestId, navigate, values, setSubmitting, setStatus, setErrors]);

  const getResponseHandler = useCallback((data) => ({ ...data.value.person, ...data.value.employeeProfile }), []);

  return (
    <DetailView
      title="Equipe / Cadastro"
      icon={<AssignmentIndIcon />}
      defaultAction={null}
      formik={formik}
      getRoute={apiRoutes.main.person.employeeById}
      getResponseHandler={getResponseHandler}
      loading={loading}
      {...props}
    >
      <IdentificationCard formik={formik} allowPj={false} />
      <AddressCard formik={formik} />
      <EmployeeCard formik={formik} />
    </DetailView>
  );
};

export default TeamDetail;
